export const EASING = 'Power1.easeIn';
